import { render, staticRenderFns } from "./ModalEstenderEtapa.vue?vue&type=template&id=33dc9681&scoped=true"
import script from "./ModalEstenderEtapa.vue?vue&type=script&lang=js"
export * from "./ModalEstenderEtapa.vue?vue&type=script&lang=js"
import style0 from "./ModalEstenderEtapa.vue?vue&type=style&index=0&id=33dc9681&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dc9681",
  null
  
)

export default component.exports